/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
function e(e){return e?.spatialReference?.isWebMercator||e?.spatialReference?.isGeographic||!1}export{e as canShowNorth};
